<template>
    <div>
        <el-form :inline="true" :model="searchForm" @submit.native.prevent>
            <el-form-item label="虚拟号：">
                <el-input v-model.trim="searchForm.virtualNo" @keyup.enter.native="getListHandler" placeholder="设备号"
                    clearable></el-input>
            </el-form-item>

            <el-form-item label="任务类型：">
                <el-select v-model="searchForm.type" clearable>
                    <el-option label="每日切网" value="0"></el-option>
                    <el-option label="每日切网(区域限制)" value="1"></el-option>
                    <el-option label="月初切网" value="2"></el-option>
                    <el-option label="电信超80G切网" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="任务状态：">
                <el-select v-model="searchForm.state" clearable>
                    <el-option label="待切换" value="0"></el-option>
                    <el-option label="切换成功" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="任务时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>

            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getListHandler($event)">查 询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border fit highlight-current-row style="width: 100%;"
            :header-cell-style="{ background: '#f5f5f5' }" :default-sort="{ prop: 'createTime', order: 'descending' }">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
            <el-table-column prop="vriNo" label="设备号" align="center"></el-table-column>
            <el-table-column prop="typeName" label="任务类型" align="center"></el-table-column>
            <el-table-column prop="stateName" label="任务状态" align="center"></el-table-column>
            <el-table-column prop="sourceIccid" label="在用卡号" align="center"></el-table-column>
            <el-table-column prop="targetName" label="切换目标" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="160" align="center"></el-table-column>
            <el-table-column prop="endTime" label="切换时间" width="160" align="center"></el-table-column>
             <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                    <el-button @click="deleteTask(scope.row.id)" type="text" style="color: red;" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage" :page-sizes="[15, 50, 100, 500]" :page-size="tbpg.pageSize" background
            layout="total, sizes, prev, pager, next, jumper" :total="tbpg.total">
        </el-pagination>

    </div>
</template>
<script>
import common from '@/utils/common.js';
export default {
    data() {
        return {
            editRules: {
                name: { required: true, message: '请输入轮训名称', trigger: 'blur' },
                type: { required: true, message: '请输入轮询类型', trigger: 'blur' },
                supplierCodes: { required: true, message: '请输入轮询通道', trigger: 'blur' }
            },
            confirmExportDialogVisible: false,
            searchForm: {
                name: '',
                supplierName: ''

            },
            branchSupplierOption: [],//运营商字典
            editVisibale: false,
            editForm: {
                id: "",
                sleepTime: "",
                name: "",
                remark: "",
                type: "",
                threadSize: "",
                state: "0",
                supplierCodes: [],
                supplierNames: "",
            },

            branchSupplierOption: [],
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
            //批量操作
            dialogVisible: false,
            limitForm: {
                supplierCode: null,
                limitSpeed: null,
            },
            statusGroup: [],
            limitFormRules: {
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            },
            //批量操作  end

            //单卡限速操作
            singleLimitDialog: false,
            singleLimitForm: {
                iccid: null,
                limitSpeed: null,
            },
            singleLimitFormRules: {
                iccid: [
                    { required: true, message: '请输入iccid', trigger: 'blur' }
                ],
                limitSpeed: [
                    { required: true, message: '请选择状态', trigger: 'change' }
                ]
            }
        }
    },
    methods: {
        toTaskInfoList(name) {
            this.$store.commit('menu/setFluxPollDetailIccid', name);
            this.$store.commit('menu/setFluxPollDetailTaskNo', "");
            if (!this.$store.state.menu.isFluxPollDetailTab) {
                let newTab = {
                    label: '轮询详情',
                    index: 'fluxPollDetail',
                    closable: true,
                    component: "views/monitor/taskInfoList"
                }
                this.$store.commit('menu/addTab', newTab);
                this.$store.commit('menu/setIsFluxPollDetailTab', true);
            }
            this.$store.commit('menu/switchTab', 'fluxPollDetail')
        },
        deleteTask(id) {
            var data = {
                id: id
            }
            this.$confirm("确定要删除操作吗？", "提示", {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {

                common.sysRequest('sim/deleteQieInfo', data, 'post').then(res => {
                    if (res.data.code == 200) {
                        this.$message.success(res.data.message);
                        this.getListHandler();
                    } else {
                        this.$message.error(res.data.message);
                    }
                })

            })
        },
        showEditDialog(data) {
            common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
            if (data) {
                this.editForm = data;
                this.editForm.supplierCodes = Array.isArray(data.supplierCodes) ? data.supplierCodes : data.supplierCodes.split("，");
            } else {
                this.editForm = {
                    id: "",
                    name: "",
                    remark: "",
                    type: "",
                    threadSize: "",
                    state: "",
                    supplierCodes: [],
                    supplierNames: "",
                };
            }
            this.editVisibale = true;
        },
        chooseAll() {
            let val = [];
            for (let i in this.branchSupplierOption) {
                val.push(this.branchSupplierOption[i].id);
            }
            this.editForm.supplierCodes = val;
        },
        cancelChooseAll() {
            this.editForm.supplierCodes = [];
        },

        confirmHandler() {
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    var d = {
                        ...this.editForm
                    }
                    d.supplierNames = "";
                    for (let j = 0; j < d.supplierCodes.length; j++) {
                        for (let i = 0; i < this.branchSupplierOption.length; i++) {
                            if (this.branchSupplierOption[i].id == d.supplierCodes[j]) {
                                d.supplierNames += this.branchSupplierOption[i].name + '(' + this.branchSupplierOption[i].alias + ')，';
                                break;
                            }
                        }
                    }
                    d.supplierCodes = d.supplierCodes.join("，");
                    if (d.supplierNames.lastIndexOf('，') == d.supplierNames.length - 1) {
                        d.supplierNames = d.supplierNames.substring(0, d.supplierNames.length - 1);
                    }
                    let path = "lunxun/add/task";
                    if (d.id && d.id != "") {
                        path = "lunxun/update/task"
                    }
                    common.sysRequest(path, d, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.cancel();
                            this.getListHandler();

                        } else {
                            this.$message.error(res.data.message);
                        }
                    })
                }
            });
        },

        cancel() {
            this.editForm = {
                id: "",
                name: "",
                remark: "",
                type: "",
                threadSize: "",
                state: "",
                supplierCodes: [],
                supplierNames: "",
            };
            this.editVisibale = false;
        },

        goToDetailPage(row) {
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        getListHandler($event) {
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            common.sysRequest('sim/selectQieInfo', data, 'post').then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },

        handleSizeChange(val) {
            this.tbpg.pageSize = val;
            this.getListHandler();
        },
        handleCurrentChange(val) {
            this.tbpg.currentPage = val;
            this.getListHandler();
        },


        handleChange(file, fileList) {
            console.log(file);
            console.log(fileList);
            if (fileList.length > 1) {
                fileList.splice(0, 1);
            }

        },
        sureRechargeHandler() {
            if (this.$refs.uploadFile.uploadFiles.length == 0) {
                this.$message.error('请选择文件');
                return;
            }
            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    this.$refs.uploadFile.submit();
                    this.rechargeVisible = false;
                }
            });
        },

        handleSuccess(res) {
            if (res.code == 200) {
                this.getListHandler();
                this.$message.success(res.message);
            } else {
                this.$message.error(res.message);
            }
            this.cancel();
            this.$refs.uploadFile.clearFiles();
        },



        formatLimitSpeed(code) {

            let v = this.statusGroup.filter(function (item) {
                if (code == item.code) {
                    return item;
                }
            });
            return v[0] && v[0].description ? v[0].description : "";
        },


        singleLimitSpeed() {
            let data = new FormData();
            Object.keys(this.singleLimitForm).forEach((key) => {
                data.append(key, this.singleLimitForm[key]);
            });

            this.$refs.limitForm.validate(valid => {
                if (valid) {
                    common.sysRequest("sim/price/limit/speed", data, 'post').then(res => {
                        if (res.data.code == 200) {
                            this.$message.success(res.data.message);
                            this.getListHandler();
                            this.cancelsSngleLimit();
                        } else {
                            this.$message.error(res.data.message)
                        }
                    }).catch(err => console.error(err));
                }
            });

        },

        cancelsSngleLimit() {
            this.singleLimitForm.limitSpeed = null;
            this.singleLimitForm.iccid = null;
            this.singleLimitDialog = false;
        },
    },

    computed: {

    },

    created() {
        this.getListHandler();

        common.getBranchSupplierOptionCom(this, 'branchSupplierOption');

        //获取状态值
        common.sysRequest('pkg/all/pkgType', {}, 'get').then(res => {
            if (res.data.code == 200) {
                this.branchSupplierOption = res.data.data;
            }
        })
    },
}
</script>
<style lang="less" scoped></style>

